export default __webpack_public_path__ + "static/1763-92038bc5f51550934aa561267cbe6fae.gif";